const COMPONENT_NAME = "ElDescriptionsItem";

export { COMPONENT_NAME };
//# sourceMappingURL=constants.mjs.map
